import { connect } from "react-redux";
import React, { useEffect } from "react";
import { Box, CircularProgress } from "@material-ui/core";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import { getFilteredExhibition } from "../../../reducer/exhibition/action";
import dayjs from "dayjs";

function ListExhibition(props) {
  useEffect(() => {
    const departmentIds = Array.isArray(props.chosenDepartmentId) ? props.chosenDepartmentId : [];
    const payload = {
      startDate: props.chosenStartDate,
      endDate: props.chosenEndDate,
      acceptedOne: true,
    };

    // Nếu không chọn khoa nào thì là toàn trường (không truyền departmentId)
    if (departmentIds.length > 0) {
      payload.departmentId = departmentIds[0];
      // Nếu chọn nhiều hơn 1 khoa, truyền các khoa còn lại vào listOtherDepartmentId
      if (departmentIds.length > 1) {
        payload.listOtherDepartmentId = departmentIds.slice(1);
      }
    }

    props.getFilteredExhibition(1, -1, payload);
  }, [props.chosenStartDate, props.chosenEndDate, props.chosenDepartmentId]);

  const getExhibitionLevelFromCode = (code) => {
    if (!code) return "-";
    let description = "-";
    props.timeResearchInformationList?.forEach((info) => {
      const detail = info.timeResearchDetail.find((d) => d.code === code);
      if (detail) {
        description = `${detail.description} (${detail.value}h)`;
      }
    });
    return description;
  };

  const getExhibitionTitle = (info, index) => {
    return (
      <div key={`exhibition-${index}`} style={{ marginTop: 16 }}>
        <div>
          <b style={{ color: "gray" }}>{index + 1}. Tên triển lãm: </b>
          <i style={{ color: "red" }}> {info.exhibition.exhibitionName}</i>
        </div>
        <div style={{ marginLeft: 20 }}>
          <b>- Tên tác phẩm: </b>
          {info.exhibition.artworkName || ""}
          <br />
          <b>- Cấp triển lãm: </b>
          {getExhibitionLevelFromCode(info.exhibition.timeResearchDetailCode)}
          <br />
          <b>- Đơn vị tổ chức: </b>
          {info.exhibition.organizer || ""}
          <br />
          <b>- Thời gian: </b>
          {info.exhibition.time ? dayjs(info.exhibition.time).format("DD/MM/YYYY") : "-"}
          <br />
          <b>- Địa điểm: </b>
          {info.exhibition.location || ""}
          <br />
        </div>
      </div>
    );
  };

  return props.isFetching ? (
    <div style={{ textAlign: "center" }}>
      <CircularProgress />
    </div>
  ) : (
    <Box paddingRight={1} height="calc(100vh - 214px)" minWidth="calc(100% + 8px)" style={{ overflowY: "auto" }}>
      {props.listExhibitionAccepted.map((item, index) => getExhibitionTitle(item, index))}
    </Box>
  );
}

const mapStateToProps = (state) => ({
  listExhibitionAccepted: select(state, "exhibitionReducer", "listFiltered"),
  isFetching: select(state, "exhibitionReducer", "isFetching"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
});

const mapDispatchToProps = (dispatch) => ({
  getFilteredExhibition: (page, pageSize, payload) => dispatch(getFilteredExhibition(page, pageSize, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ListExhibition));

